import { NavLink, Route, Routes } from "react-router-dom";
import { Dashboard } from "./screens/Dashboard";
import { ServiceTargets } from "./screens/ServiceTargets";
import { ApiKeys } from "./screens/ApiKeys";
import { CapabilityView } from "./screens/CapabilityView";
import { CAPABILITY_CONFIGS } from "./lib/capabilities";
import { SessionProvider, useSession } from "./lib/session";

const navClass = ({ isActive }: { isActive: boolean }) => (isActive ? "active" : "");

/** No session: one button, and it is a link — sign-in is a redirect to Rathvan ID, not a form here. */
function SignIn() {
  const { problem } = useSession();
  return (
    <div className="panel" style={{ maxWidth: 480, margin: "48px auto", textAlign: "center" }}>
      <h2>Sign in</h2>
      <p className="muted">
        Platform Hub signs you in through Rathvan ID. Your tenant and role come from your grant there.
      </p>
      <a href="/v1/auth/login" className="button" style={{
        display: "inline-block", marginTop: 12, padding: "10px 20px", background: "var(--accent)",
        borderRadius: 6, color: "#fff", textDecoration: "none", fontWeight: 600,
      }}>
        Sign in with Rathvan ID
      </a>
      {problem && problem.status !== 401 && (
        <p className="err" style={{ marginTop: 16 }}>
          The API could not be reached: {problem.message}{problem.hint ? ` — ${problem.hint}` : ""}
        </p>
      )}
    </div>
  );
}

function Shell() {
  const { session, signOut } = useSession();

  return (
    <div className="wrap">
      <header className="app">
        <h1>Platform Hub</h1>
        <span className="tag">platform.rathvan.com — orchestration for a product's services</span>
        {session?.signedIn && (
          <span className="session" style={{ marginLeft: "auto", display: "flex", gap: 12, alignItems: "center" }}>
            <span className="muted">
              {session.displayName} · <span className="tenant-name">{session.tenantId}</span> · <span className="pill s-muted">{session.role}</span>
            </span>
            <button type="button" onClick={() => { void signOut(); }}
              style={{ padding: "6px 12px", background: "transparent", border: "1px solid var(--border)", borderRadius: 6, color: "var(--text)", cursor: "pointer" }}>
              Sign out
            </button>
          </span>
        )}
      </header>

      {session === null && <p className="muted">Checking your session…</p>}
      {session?.signedIn === false && <SignIn />}
      {session?.signedIn && (
        <>
          <nav className="tabs">
            <NavLink to="/" end className={navClass}>Dashboard</NavLink>
            <NavLink to="/targets" className={navClass}>Service targets</NavLink>
            <NavLink to="/keys" className={navClass}>Machine keys</NavLink>
          </nav>

          {/* The seven capabilities, generated from their config so a new one is a data entry. */}
          <nav className="tabs">
            {CAPABILITY_CONFIGS.map((c) => (
              <NavLink key={c.id} to={`/c/${c.id}`} className={navClass}>{c.title}</NavLink>
            ))}
          </nav>

          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/targets" element={<ServiceTargets />} />
            <Route path="/keys" element={<ApiKeys />} />
            {CAPABILITY_CONFIGS.map((c) => (
              <Route key={c.id} path={`/c/${c.id}`} element={<CapabilityView config={c} />} />
            ))}
          </Routes>
        </>
      )}
    </div>
  );
}

export function App() {
  return (
    <SessionProvider>
      <Shell />
    </SessionProvider>
  );
}
